@if (label) {
    <label class="form-label">{{ label }}</label>
}
@if(!isReadOnly)
{
    <dx-file-uploader selectButtonText="Upload Files" labelText="or Drag and Drop files here" uploadMode="useForm"
        [value]="value" [multiple]="true" [maxFileSize]="maxFileSize" (onValueChanged)="handleValueChanged($event)">
        @if (validators.length > 0) {
            <dx-validator [validationRules]="validators"/>
        }
    </dx-file-uploader>
}
@if (existingFiles?.length > 0) {
    @for (file of existingFiles; track file) {
        <div class="d-flex align-items-center gap-2 mt-2">
            <a href="#" [appSignedLink]="file.fileUrl" class="text-decoration-none">
                <i class="dx-icon-attach"></i> {{ file.fileName }}
            </a>
            @if (!isReadOnly) {
                <dx-button icon="trash" type="danger" stylingMode="text" (onClick)="handleDelete(file)"></dx-button>
            }
        </div>
    }
}
